/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useTheme } from '@material-ui/core';

import { useImgSrc } from 'core/utils/use-img-src.hook';
import { ICustomTheme } from 'interfaces';
import { MediaObjectType } from 'interfaces/mediaObject.types';
import noThumbnailProduct from 'assets/icons/mountain.svg';

export default function ProductThumbnail({
  thumbnail,
  className,
}: {
  thumbnail?: MediaObjectType | null;
  className?: string;
}): JSX.Element {
  const theme: ICustomTheme = useTheme();
  const { fullUri } = useImgSrc(thumbnail || undefined) || {};

  return (
    <div
      className={className}
      css={{
        ...(!fullUri && {
          display: 'grid',
          placeItems: 'center',
          backgroundColor: theme.colors.grey.light5,
        }),
        width: 140,
        height: 140,
        margin: '0 auto',
      }}
    >
      {fullUri ? (
        <img
          css={{ width: '100%', height: '100%', objectFit: 'cover' }}
          alt="product's thumbnail"
          src={fullUri}
        />
      ) : (
        <img css={{ width: 42 }} src={noThumbnailProduct} alt="mountain" />
      )}
    </div>
  );
}
